import React, { CSSProperties } from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function CancelIcon({
  className,
  style,
  color = "#050530",
  backgroundColor = "#F9FBFE",
  ...props
}: IconProps & { color?: CSSProperties["color"]; backgroundColor?: CSSProperties["color"] }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 26 27'
      fill='none'
      {...props}
    >
      <circle cx='13' cy='13.1992' r='13' fill={backgroundColor} />
      <path
        d='M18 8.19922L8 18.1992'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 8.19922L18 18.1992'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
